export const categoriasAtividadeEnum = [
  { value: 1, enumValue: "RURAL", label: "Produtor Rural" },
  { value: 2, enumValue: "PESCADOR", label: "Pescador" },
  {
    value: 3,
    enumValue: "SERINGUEIRO",
    label: "Seringueiro ou Extrativista Vegetal"
  }
];

export const situacoesFamiliarEnum = [
  { value: 0, enumValue: "INDIVIDUALMENTE", label: "Individualmente" },
  {
    value: 1,
    enumValue: "REGIME_ECONOMIA_FAMILIAR",
    label: "Regime de Economia Familiar"
  }
];

export const condicaoEmRelacaoAoImovelEnum = [
  { value: 1, enumValue: "PROPRIETARIO", label: "Proprietário" },
  { value: 11, enumValue: "ACAMPADO", label: "Acampado" },
  { value: 4, enumValue: "ARRENDATARIO", label: "Arrendatário" },
  { value: 10, enumValue: "ASSENTADO", label: "Assentado" },
  { value: 3, enumValue: "COMODATARIO", label: "Comodatário" },
  { value: 8, enumValue: "CONDOMINIO", label: "Condômino" },
  { value: 6, enumValue: "MEEIRO", label: "Meeiro" },
  { value: 5, enumValue: "PARCEIRO", label: "Parceiro" },
  { value: 9, enumValue: "POSSEIRO", label: "Posseiro" },
  { value: 2, enumValue: "POSSUIDOR", label: "Possuidor" },
  { value: 7, enumValue: "USUFRUTARIO", label: "Usufrutuário" },
  { value: 12, enumValue: "QUILOMBOLA", label: "Quilombola" }
];

export const siglasUFEnum = [
  { value: "AC", enumValue: "ACRE", label: "Acre" },
  { value: "AL", enumValue: "ALAGOAS", label: "Alagoas" },
  { value: "AP", enumValue: "AMAPA", label: "Amapá" },
  { value: "AM", enumValue: "AMAZONAS", label: "Amazonas" },
  { value: "BA", enumValue: "BAHIA", label: "Bahia" },
  { value: "CE", enumValue: "CEARA", label: "Ceará" },
  { value: "DF", enumValue: "DISTRITO_FEDERAL", label: "Distrito Federal" },
  { value: "ES", enumValue: "ESPIRITO_SANTO", label: "Espírito Santo" },
  { value: "GO", enumValue: "GOIAS", label: "Goiás" },
  { value: "MA", enumValue: "MARANHAO", label: "Maranhão" },
  { value: "MT", enumValue: "MATO_GROSSO", label: "Mato Grosso" },
  { value: "MS", enumValue: "MATO_GROSSO_DO_SUL", label: "Mato Grosso do Sul" },
  { value: "MG", enumValue: "MINAS_GERAIS", label: "Minas Gerais" },
  { value: "PA", enumValue: "PARA", label: "Pará" },
  { value: "PB", enumValue: "PARAIBA", label: "Paraíba" },
  { value: "PR", enumValue: "PARANA", label: "Paraná" },
  { value: "PE", enumValue: "PERNAMBUCO", label: "Pernambuco" },
  { value: "PI", enumValue: "PIAUI", label: "Piauí" },
  {
    value: "RN",
    enumValue: "RIO_GRANDE_DO_NORTE",
    label: "Rio Grande do Norte"
  },
  { value: "RS", enumValue: "RIO_GRANDE_DO_SUL", label: "Rio Grande do Sul" },
  { value: "RJ", enumValue: "RIO_DE_JANEIRO", label: "Rio de janeiro" },
  { value: "RO", enumValue: "RONDONIA", label: "Rondônia" },
  { value: "RR", enumValue: "RORAIMA", label: "Roráima" },
  { value: "SC", enumValue: "SANTA_CATARINA", label: "Santa Catarina" },
  { value: "SP", enumValue: "SAO_PAULO", label: "São Paulo" },
  { value: "SE", enumValue: "SERGIPE", label: "Sergipe" },
  { value: "TO", enumValue: "TOCANTINS", label: "Tocantíns" }
];

export const cessaoTerraEnum = [
  { value: 1, enumValue: "ARRENDATARIO", label: "Arrendamento" },
  { value: 2, enumValue: "PARCEIRO", label: "Parceria" },
  { value: 3, enumValue: "MEEIRO", label: "Meação" },
  { value: 4, enumValue: "COMODATARIO", label: "Comodato" }
];

export const relacaoPescadorEmbarcacaoEnum = [
  { value: 1, enumValue: "ARRENDATARIO", label: "Arrendatário" },
  { value: 4, enumValue: "COMODATARIO", label: "Comodatário" },
  {
    value: 7,
    enumValue: "MARISCADOR_SEM_EMBARCACAO",
    label: "Mariscador sem embarcação"
  },
  { value: 3, enumValue: "MEEIRO", label: "Meeiro" },
  { value: 2, enumValue: "PARCEIRO", label: "Parceiro" },
  {
    value: 6,
    enumValue: "PESCADOR_ARTESANAL",
    label: "Pescador artesanal sem embarcação"
  },
  { value: 5, enumValue: "PROPRIETARIO", label: "Proprietário" }
];

export const estadosCiviesEnum = [
  { value: 1, enumValue: "SOLTEIRO", label: "Solteiro" },
  { value: 2, enumValue: "CASADO", label: "Casado" },
  { value: 3, enumValue: "VIUVO", label: "Viuvo" },
  { value: 4, enumValue: "DIVORCIADO", label: "Divorciado" },
  { value: 5, enumValue: "SEPARADO", label: "Separado" },
  { value: 6, enumValue: "UNIAO_ESTAVEL", label: "União Estável" }
];

export const parentescosEnum = [
  { value: 4, enumValue: "CONJUGE", label: "Cônjuge" },
  { value: 3, enumValue: "COMPANHEIRO", label: "Companheiro(a)" },
  { value: 2, enumValue: "FILHO", label: "Filho(a)" },
  { value: 5, enumValue: "PAIS", label: "Pai/Mãe" },
  { value: 1, enumValue: "EQUIPARADO_FILHO", label: "Equiparação com Filho(a)" }
];

export const gruposFamiliaresEnum = [
  { value: 0, enumValue: "TITULAR", label: "Titular" },
  { value: 1, enumValue: "COMPONENTE", label: "Componente" }
];

export const finalidadesEnum = [
  { value: 1, enumValue: "SUBSISTENCIA", label: "Subsistência" },
  { value: 2, enumValue: "VENDA", label: "Venda" },
  { value: 3, enumValue: "AMBAS", label: "Venda e Subsistência" }
];

export const tipoCooperativaEnum = [
  { value: 1, enumValue: "AGROPECUARIA", label: "Agropecuária" },
  { value: 2, enumValue: "CREDITO_RURAL", label: "Crédito Rural" },
  { value: 3, enumValue: "OUTROS", label: "Outros" }
];

export const tipoAtividadeEnum = [
  {
    value: 1,
    enumValue: "TURISTICA",
    label: "Turística"
  },
  { value: 2, enumValue: "ARTISTICA", label: "Artística" },
  { value: 3, enumValue: "ARTESANAL", label: "Artesanal" },
  {
    value: 4,
    enumValue: "DIRIGENTE_SINDICAL",
    label: "Dirigente sindical"
  },
  {
    value: 5,
    enumValue: "DIRIGENTE_COOPERATIVA",
    label: "Dirigente de cooperativa"
  },
  { value: 6, enumValue: "MANDATO_VEREADOR", label: "Mandato de vereador" }
  //{ value: 6, enumValue: 'OUTROS', label: 'Outros' }
];

export const localExerceAtividadePescadorEnum = [
  {
    value: 1,
    enumValue: "MAR",
    label: "Mar"
  },
  { value: 2, enumValue: "RIO", label: "Rio" },
  { value: 3, enumValue: "ESTUARIO", label: "Estuário" },
  {
    value: 4,
    enumValue: "LAGOA",
    label: "Lagoa"
  },
  { value: 5, enumValue: "ACUDE", label: "Açude" },
  { value: 6, enumValue: "REPRESA", label: "Represa" }
];

/**
 * Obter o código (value) da enum através do enumValue (Valor equivalente ao valor da enum no backend)
 * @param {*} enumValue  o valor da enum que se está buscando
 * @param {*} objeto a Enum (objeto) onde será verificar se o valor existe
 * @returns o valor do codigo da enum
 */
export const getCodigoValuePorEnumValue = (enumValue, objeto) => {
  let itemSelecionado = objeto.find(
    (enumSelecionada) => String(enumSelecionada.enumValue) === enumValue
  );
  return itemSelecionado ? itemSelecionado.value : enumValue + "não mapeado";
};

/**
 * Obter o valor da Lable da enum através do enumValue (Valor equivalente ao valor da enum no backend)
 * @param {*} enumValue  o valor da enum que se está buscando
 * @param {*} objeto a Enum (objeto) onde será verificar se o valor existe
 * @returns o valor do codigo da enum
 */
export const getLableValuePorEnumValue = (enumValue, objeto) => {
  let itemSelecionado = objeto.find(
    (enumSelecionada) => String(enumSelecionada.enumValue) === enumValue
  );
  return itemSelecionado ? itemSelecionado.label : enumValue + "não mapeado";
};

/**
 * Obter o valor da Lable da enum através do código  (value)
 * @param {*} codigo  o código (value) da enum que se está buscando
 * @param {*} objeto a Enum (objeto) onde será verificar se o valor existe
 * @returns o valor do codigo da enum
 */
export const getLableValuePorCodigo = (codigo, objeto) => {
  let itemSelecionado = objeto.find(
    (enumSelecionada) => String(enumSelecionada.value) === String(codigo)
  );
  if (itemSelecionado && itemSelecionado.label) {
    return itemSelecionado.label;
  }
  return codigo + "Não mapeado";
};

export const simNaoEnum = [
  { value: "SIM", enumValue: "SIM", label: "Sim" },
  { value: "NAO", enumValue: "NAO", label: "Não" }
];

export const deveInformarCessaoDaTerra = (codigocondicaoEmRelacaoAoImovel) => {
  let deveInformarCessaoDaTerra =
    codigocondicaoEmRelacaoAoImovel &&
    (codigocondicaoEmRelacaoAoImovel ===
      getCodigoValuePorEnumValue(
        "PROPRIETARIO",
        condicaoEmRelacaoAoImovelEnum
      ) ||
      codigocondicaoEmRelacaoAoImovel ===
        getCodigoValuePorEnumValue(
          "ASSENTADO",
          condicaoEmRelacaoAoImovelEnum
        ) ||
      codigocondicaoEmRelacaoAoImovel ===
        getCodigoValuePorEnumValue("POSSEIRO", condicaoEmRelacaoAoImovelEnum) ||
      codigocondicaoEmRelacaoAoImovel ===
        getCodigoValuePorEnumValue(
          "POSSUIDOR",
          condicaoEmRelacaoAoImovelEnum
        ) ||
      codigocondicaoEmRelacaoAoImovel ===
        getCodigoValuePorEnumValue(
          "USUFRUTARIO",
          condicaoEmRelacaoAoImovelEnum
        ));

  return deveInformarCessaoDaTerra;
};

export const deveInformarSituacaoFamiliar = (codigoSituacaoFamiliar) => {
  let deveInformarSituacaoFamiliar =
    codigoSituacaoFamiliar &&
    codigoSituacaoFamiliar ===
      getCodigoValuePorEnumValue(
        "REGIME_ECONOMIA_FAMILIAR",
        situacoesFamiliarEnum
      );
  return deveInformarSituacaoFamiliar;
};
